import { flatListToHierarchical } from '@utils/flatListToHierarchical';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import FooterForm from './Forms/FooterForm';

const Footer = () => {
  const data = useStaticQuery(graphql`
    {
      wpMenu(locations: { eq: GATSBY_FOOTER_MENU }) {
        id
        name
        menuItems {
          nodes {
            id
            label
            path
            parentId
          }
        }
      }
    }
  `);

  const { nodes } = data.wpMenu.menuItems;

  const menuItems = flatListToHierarchical(nodes);

  const [home, quickLinks, getInvolved] = menuItems;

  return (
    <footer>
      <div className='footer'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='row f-bottom-row'>
                <div className='col-md-3 f-menu-col footer-address-col'>
                  <div className='footer-brand'>
                    <Link to={home.path}>
                      <StaticImage
                        src='../images/worldsavvy-brand.svg'
                        alt='World Savvy Logo'
                      />
                    </Link>
                  </div>
                  <p>
                    <a href='mailto:info@worldsavvy.org'>info@worldsavvy.org</a>
                  </p>
                  <p>
                    <a href='tel:612-314-6567'>612-314-6567</a>
                  </p>
                  <div className='f-social-sec'>
                    <ul className='f-social-media'>
                      <li>
                        <a
                          href='https://www.facebook.com/WorldSavvy'
                          target='_blank'
                          rel='noreferrer'
                          aria-label='Facebook'
                        >
                          <svg
                            width='22'
                            height='22'
                            viewBox='0 0 22 22'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M9.30756 19.7992H12.5306V11.7692H15.2256L15.6326 8.64522H12.5306V6.64322C12.5306 5.74122 12.7836 5.12522 14.0816 5.12522H15.7426V2.32022C15.4566 2.28722 14.4776 2.19922 13.3336 2.19922C10.9356 2.19922 9.30756 3.66222 9.30756 6.33522V8.64522H6.60156V11.7692H9.30756V19.7992Z'
                              fill='white'
                            />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://www.instagram.com/worldsavvy/'
                          target='_blank'
                          rel='noreferrer'
                          aria-label='Instagram'
                        >
                          <svg
                            width='22'
                            height='22'
                            viewBox='0 0 22 22'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.1487 1.83203H14.8487C17.782 1.83203 20.1654 4.21536 20.1654 7.1487V14.8487C20.1654 16.2588 19.6052 17.6111 18.6082 18.6082C17.6111 19.6052 16.2588 20.1654 14.8487 20.1654H7.1487C4.21536 20.1654 1.83203 17.782 1.83203 14.8487V7.1487C1.83203 5.73863 2.39218 4.38632 3.38925 3.38925C4.38632 2.39218 5.73863 1.83203 7.1487 1.83203ZM6.96536 3.66536C6.09015 3.66536 5.25078 4.01304 4.63191 4.63191C4.01304 5.25078 3.66536 6.09015 3.66536 6.96536V15.032C3.66536 16.8562 5.1412 18.332 6.96536 18.332H15.032C15.9072 18.332 16.7466 17.9844 17.3655 17.3655C17.9844 16.7466 18.332 15.9072 18.332 15.032V6.96536C18.332 5.1412 16.8562 3.66536 15.032 3.66536H6.96536ZM15.8112 5.04036C16.1151 5.04036 16.4065 5.16109 16.6214 5.37597C16.8363 5.59086 16.957 5.8823 16.957 6.1862C16.957 6.49009 16.8363 6.78154 16.6214 6.99642C16.4065 7.21131 16.1151 7.33203 15.8112 7.33203C15.5073 7.33203 15.2159 7.21131 15.001 6.99642C14.7861 6.78154 14.6654 6.49009 14.6654 6.1862C14.6654 5.8823 14.7861 5.59086 15.001 5.37597C15.2159 5.16109 15.5073 5.04036 15.8112 5.04036ZM10.9987 6.41536C12.2143 6.41536 13.3801 6.89825 14.2396 7.75779C15.0991 8.61733 15.582 9.78312 15.582 10.9987C15.582 12.2143 15.0991 13.3801 14.2396 14.2396C13.3801 15.0991 12.2143 15.582 10.9987 15.582C9.78312 15.582 8.61733 15.0991 7.75779 14.2396C6.89825 13.3801 6.41536 12.2143 6.41536 10.9987C6.41536 9.78312 6.89825 8.61733 7.75779 7.75779C8.61733 6.89825 9.78312 6.41536 10.9987 6.41536ZM10.9987 8.2487C10.2694 8.2487 9.56988 8.53843 9.05415 9.05415C8.53843 9.56988 8.2487 10.2694 8.2487 10.9987C8.2487 11.728 8.53843 12.4275 9.05415 12.9432C9.56988 13.459 10.2694 13.7487 10.9987 13.7487C11.728 13.7487 12.4275 13.459 12.9432 12.9432C13.459 12.4275 13.7487 11.728 13.7487 10.9987C13.7487 10.2694 13.459 9.56988 12.9432 9.05415C12.4275 8.53843 11.728 8.2487 10.9987 8.2487Z'
                              fill='white'
                            />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://www.linkedin.com/company/world-savvy'
                          target='_blank'
                          rel='noreferrer'
                          aria-label='Linkedin'
                        >
                          <svg
                            width='23'
                            height='22'
                            viewBox='0 0 23 22'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M6.05924 20V7.85543H1.98639V20H6.05924ZM4.02334 6.1963C5.44362 6.1963 6.32767 5.26374 6.32767 4.09835C6.30121 2.90668 5.44367 2 4.0503 2C2.65714 2 1.74609 2.9067 1.74609 4.09835C1.74609 5.26379 2.62993 6.1963 3.99675 6.1963H4.02322H4.02334ZM8.31355 20H12.3864V13.2179C12.3864 12.8549 12.4129 12.4923 12.5204 12.2328C12.8149 11.5076 13.485 10.7565 14.6101 10.7565C16.0839 10.7565 16.6735 11.8702 16.6735 13.5028V19.9999H20.7461V13.0363C20.7461 9.30599 18.7368 7.57031 16.0571 7.57031C13.8599 7.57031 12.8952 8.78751 12.3593 9.61653H12.3865V7.85518H8.31365C8.36709 8.99476 8.31365 19.9997 8.31365 19.9997L8.31355 20Z'
                              fill='white'
                            />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://www.youtube.com/@worldsavvy5598'
                          target='_blank'
                          rel='noreferrer'
                          aria-label='Youtube'
                        >
                          <svg
                            width='23'
                            height='23'
                            viewBox='0 0 23 23'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M22.52 6.35144C22.389 5.86382 22.1323 5.41913 21.7756 5.06189C21.4188 4.70465 20.9744 4.44739 20.4869 4.31584C18.6926 3.83325 11.5 3.83325 11.5 3.83325C11.5 3.83325 4.30737 3.83325 2.51306 4.31327C2.02539 4.44439 1.5808 4.70152 1.22394 5.05882C0.867087 5.41613 0.610525 5.86104 0.480022 6.34888C-9.79219e-08 8.14575 0 11.8935 0 11.8935C0 11.8935 -9.79219e-08 15.6413 0.480022 17.4356C0.74442 18.4264 1.52478 19.2068 2.51306 19.4712C4.30737 19.9538 11.5 19.9538 11.5 19.9538C11.5 19.9538 18.6926 19.9538 20.4869 19.4712C21.4778 19.2068 22.2556 18.4264 22.52 17.4356C23 15.6413 23 11.8935 23 11.8935C23 11.8935 23 8.14575 22.52 6.35144ZM9.2154 15.3333V8.45379L15.1708 11.8679L9.2154 15.3333Z'
                              fill='white'
                            />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className='footer-logo-sec hide-m'>
                    <div className='f-logo-col'><StaticImage
                        src='../images/candid-logo.jpg'
                        alt='Candid logo'
                      /></div>
                      <div className='f-logo-col'><StaticImage
                        src='../images/charity-logo.png'
                        alt='Charity logo'
                      /></div>
                  </div>
                </div>
                <div className='col-md-3 f-menu-col'>
                  <div className='heading-level-5-i text-uppercase'>
                    {quickLinks.label}
                  </div>
                  <ul className='f-menu'>
                    {quickLinks.children.map((item, index) => (
                      <li key={index}>
                        {/^\/(?!\/)/.test(item.path) ? <Link to={item.path}>{item.label}</Link> : <a href={item.path}>{item.label}</a>}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className='col-md-3 f-menu-col'>
                  <div className='heading-level-5-i text-uppercase'>
                    {getInvolved.label}
                  </div>
                  <ul className='f-menu'>
                    {getInvolved.children.map(item => (
                      <li key={item.id}>
                        {/^\/(?!\/)/.test(item.path) ? <Link to={item.path}>{item.label}</Link> : <a href={item.path}>{item.label}</a>}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className='col-md-3 f-menu-col'>
                  <div className='heading-level-5-i text-uppercase'>
                    Stay in touch
                  </div>
                  <p>
                    Sign up below to stay informed and hear about opportunities
                    to get engaged.
                  </p>
                  <div className='footer-form-sec radio-check-label-sec'>
                    <FooterForm />
                    <div className='footer-logo-sec hide-desk'>
                    <div className='f-logo-col'><StaticImage
                        src='../images/candid-logo.jpg'
                        alt='Candid logo'
                      /></div>
                      <div className='f-logo-col'><StaticImage
                        src='../images/charity-logo.png'
                        alt='Charity logo'
                      /></div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-12'>
              <div className='footer-copyright-sec text-center'>
                <p>
                  © {new Date().getFullYear()} - World Savvy | All rights
                  reserved
                  <br />
                  World Savvy is a 501(c)3 not-for-profit corporation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
